import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber usar Meta Ads?',
  a: 'No necesitás ser experto. La guía está pensada para ayudarte a entender cómo pensar anuncios y campañas para vender iPhones. No es un curso técnico avanzado de Meta Ads, sino una guía práctica para saber qué anunciar, cómo comunicarlo, cómo generar conversaciones y cómo analizar los resultados.'
}, {
  q: '¿Me sirve si recién estoy empezando a vender iPhones?',
  a: 'Sí. De hecho, te va a ayudar a ordenar mejor qué modelos ofrecer, cómo crear anuncios y cómo evitar errores comunes desde el inicio.'
}, {
  q: '¿Me sirve si ya tengo una tienda?',
  a: 'Sí. Especialmente si ya vendés pero querés mejorar la calidad de las consultas y dejar de depender solo del contenido orgánico o de agencias.'
}, {
  q: '¿La guía es en PDF?',
  a: 'Sí. Es una guía práctica en PDF que podés leer a tu ritmo y volver a consultar cuando quieras. Los dos bonus también son PDFs.'
}, {
  q: '¿Qué bonus incluye?',
  a: 'Incluye dos bonus: 1) Estructura de Campañas para vender iPhones con Instagram Ads — enfocado en armar, organizar y optimizar campañas. 2) Creación de Contenido para vender iPhones con Reels y Anuncios — enfocado en crear el contenido que después usás como anuncio.'
}, {
  q: '¿Necesito mucho presupuesto para hacer anuncios?',
  a: 'No necesitás empezar con presupuestos enormes. La guía te enseña a pensar campañas simples y ordenadas para validar qué anuncios funcionan.'
}, {
  q: '¿Cómo puedo pagar?',
  a: 'El pago se realiza a través de Mercado Pago, con los medios de pago disponibles dentro de la plataforma. Una vez completada la compra, vas a poder acceder al material digital correspondiente.'
}, {
  q: '¿Es solo para Argentina?',
  a: 'No. La estrategia está pensada para tiendas y vendedores de iPhone de habla hispana que venden por Instagram y mensajes. Algunas referencias pueden estar adaptadas al mercado argentino, pero los principios de campañas, contenido, ofertas, conversaciones y análisis aplican a cualquier tienda que venda iPhones por redes sociales. El precio puede mostrarse en ARS según la configuración de pago disponible.'
}, {
  q: '¿Esto reemplaza una agencia?',
  a: 'El objetivo es que entiendas cómo funciona la publicidad para tu negocio y puedas tomar mejores decisiones, ya sea que ejecutes vos o que después delegues con más criterio.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-32 bg-zinc-50" data-id="element-102">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-103">
        <div className="text-center mb-12" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900" data-id="element-105">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-106">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-zinc-200 rounded-2xl overflow-hidden" data-id="element-107">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-108">
                <span className="font-semibold text-zinc-900 pr-8" data-id="element-109">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-zinc-500 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-110" />
              </button>
              <AnimatePresence data-id="element-111">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-112">
                    <div className="px-6 pb-6 text-zinc-600 leading-relaxed" data-id="element-113">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}